import React from "react";
import Button from "@material-ui/core/Button";
import IntlMessages from "util/IntlMessages";

const Footer = () => {
    return (
      <footer className="app-footer" style={{ display: "flex", justifyContent: "center" }}>
        <span className="d-inline">
          Copyright Sidmach Technologies &copy; 2025
        </span>
      </footer>
    );
  }
;

export default Footer;
